// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__34ABH","icon--small":"Icon_icon--small__1BG_v","icon--big":"Icon_icon--big__1oSPm"};